import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import classnames from 'classnames';
import icons, { IconType, iconsWithDynamicColor } from './icon-data';
import styles from './index.module.less';
export const Icon = memo(({ type, iconUrl, size, className, style, color, ...rest }) => {
    const iconSize = size ?? 24;
    const isDynamicColor = type && iconsWithDynamicColor.includes(type);
    const iconStyle = useMemo(() => {
        const bg = isDynamicColor
            ? null
            : {
                backgroundImage: `url(${iconUrl ?? icons[type]})`,
                backgroundSize: `${iconSize}px`,
            };
        return {
            height: `${iconSize}px`,
            width: `${iconSize}px`,
            color,
            ...bg,
            ...style,
        };
    }, [iconSize, iconUrl, type, isDynamicColor, color]);
    return (_jsx("span", { "aria-hidden": "true", dangerouslySetInnerHTML: isDynamicColor
            ? {
                __html: icons[type],
            }
            : undefined, ...rest, className: classnames(styles.icon, className), style: iconStyle }));
});
export const LoadingIcon = (props) => {
    return (_jsx(Icon, { size: 24, className: classnames(props.className, styles.spinning), type: "loading", ...props }));
};
export const LoadingCircle = (props) => {
    return (_jsx(Icon, { size: 24, className: classnames(props.className, styles.spinning2x), type: "loadingCircle", ...props }));
};
export { icons };
